export const LIKE = 'like';

export const VISIT = 'visit';



// WEBPACK FOOTER //
// ./app/constants/recordEventType.js